/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import React from 'react';
import { lineChartDefaults, LineChartProps } from './LineChart.props';
import { getLineChartGeneralOptions } from './utils/GetLineChartGeneralOptions/getLineChartGeneralOptions';
import { getLineChartLegendOptions } from './utils/GetLineChartLegendOptions/getLineChartLegendOptions';
import { getLineChartLineData } from './utils/GetLineChartLineData/getLineChartLineData';

HighchartsAccessibility(Highcharts);

/**
 * SDS Line Chart.
 */
export const LineChart = (props: LineChartProps): JSX.Element => {
  const allProps: LineChartProps = { ...lineChartDefaults, ...props };
  const { classes } = allProps;

  const chartClass = clsx(`sds-chart`, `sds-chart--line`, classes);

  const options: Highcharts.Options = {
    ...getLineChartGeneralOptions(allProps),
    ...getLineChartLineData(allProps),
    ...getLineChartLegendOptions(allProps),
  };

  return (
    <div className={chartClass}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};
